export default "<p>categories-report works!</p>\r\n"